"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _throttleDebounce = require("throttle-debounce");
var _fileSaver = require("file-saver");
var _clipboard = _interopRequireDefault(require("clipboard"));
var _render = _interopRequireDefault(require("@/components/FormGenerator/components/render/render"));
var _FormDrawer = _interopRequireDefault(require("./FormDrawer"));
var _JsonDrawer = _interopRequireDefault(require("./JsonDrawer"));
var _RightPanel = _interopRequireDefault(require("./RightPanel"));
var _config = require("@/components/FormGenerator/components/generator/config");
var _index = require("../utils/index");
var _html = require("@/components/FormGenerator/components/generator/html");
var _js = require("@/components/FormGenerator/components/generator/js");
var _css = require("@/components/FormGenerator/components/generator/css");
var _drawingDefalut = _interopRequireDefault(require("@/components/FormGenerator/components/generator/drawingDefalut"));
var _CodeTypeDialog = _interopRequireDefault(require("./CodeTypeDialog"));
var _DraggableItem = _interopRequireDefault(require("./DraggableItem"));
var _db = require("../utils/db");
var _validate = require("@/utils/validate");
var systemFormConfigApi = _interopRequireWildcard(require("@/api/systemFormConfig.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import logo from '@/assets/logo.png'
var beautifier;
var emptyActiveData = {
  style: {},
  autosize: {}
};
var oldActiveId;
var tempActiveData;
var drawingListInDB = (0, _db.getDrawingList)();
var formConfInDB = (0, _db.getFormConf)();
var idGlobal = (0, _db.getIdGlobal)();
var _default2 = exports.default = {
  components: {
    draggable: _vuedraggable.default,
    render: _render.default,
    FormDrawer: _FormDrawer.default,
    JsonDrawer: _JsonDrawer.default,
    RightPanel: _RightPanel.default,
    CodeTypeDialog: _CodeTypeDialog.default,
    DraggableItem: _DraggableItem.default
  },
  props: {
    permission: {
      type: String,
      default: 'admin:system:form:update'
    },
    editData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /** 与 editData 二选一：部分页面误用 prent-data 传参，此处兼容以拿到 formId / content */
    prentData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isCreate: {
      type: Number,
      default: 0 // 0=创建，1=编辑
    },
    /** 为 false 时（如自定义租户表单）仅改画布字段名，不调服务端批量同步配置表 */
    serverFieldRename: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      // logo,
      idGlobal: idGlobal,
      formConf: _config.formConf,
      inputComponents: _config.inputComponents,
      selectComponents: _config.selectComponents,
      layoutComponents: _config.layoutComponents,
      labelWidth: 100,
      drawingList: _drawingDefalut.default,
      drawingData: {},
      activeId: _drawingDefalut.default[0].formId,
      drawerVisible: false,
      formData: {},
      dialogVisible: false,
      jsonDrawerVisible: false,
      generateConf: null,
      showFileName: false,
      activeData: _drawingDefalut.default[0],
      saveDrawingListDebounce: (0, _throttleDebounce.debounce)(340, _db.saveDrawingList),
      saveIdGlobalDebounce: (0, _throttleDebounce.debounce)(340, _db.saveIdGlobal),
      leftComponents: [{
        title: '输入型组件',
        list: _config.inputComponents
      }, {
        title: '选择型组件',
        list: _config.selectComponents
      }, {
        title: '布局型组件',
        list: _config.layoutComponents
      }],
      selfForm: {
        name: null,
        info: null,
        id: null
      },
      renameLegacyDialog: {
        visible: false,
        target: null,
        newVModel: ''
      },
      renameLegacySubmitting: false
    };
  },
  computed: {},
  watch: {
    // eslint-disable-next-line func-names
    'activeData.__config__.label': function activeData__config__Label(val, oldVal) {
      if (this.activeData.placeholder === undefined || !this.activeData.__config__.tag || oldActiveId !== this.activeId) {
        return;
      }
      this.activeData.placeholder = this.activeData.placeholder.replace(oldVal, '') + val;
    },
    activeId: {
      handler: function handler(val) {
        oldActiveId = val;
      },
      immediate: true
    },
    drawingList: {
      handler: function handler(val) {
        this.saveDrawingListDebounce(val);
        if (val.length === 0) this.idGlobal = 100;
      },
      deep: true
    },
    idGlobal: {
      handler: function handler(val) {
        this.saveIdGlobalDebounce(val);
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    var load = this.editData && this.editData.content ? this.editData : this.prentData && this.prentData.content ? this.prentData : null;
    if (load && load.content) {
      var id = load.id,
        name = load.name,
        info = load.info,
        content = load.content;
      this.selfForm.name = name;
      this.selfForm.id = id;
      this.selfForm.info = info;
      content = JSON.parse(content);
      this.drawingList = content.fields;
      var _content = JSON.parse(JSON.stringify(content));
      delete _content.fields;
      this.formConf = _content;
      this.markLegacyFields(this.drawingList);
    }
    // if (Array.isArray(drawingListInDB) && drawingListInDB.length > 0) {
    //   this.drawingList = drawingListInDB
    // } else {
    //   this.drawingList = drawingDefalut
    // }
    if (this.drawingList && this.drawingList.length) {
      this.activeFormItem(this.drawingList[0]);
    }
    // if (formConfInDB) {
    //   this.formConf = formConfInDB
    // }
    var clipboard = new _clipboard.default('#copyNode', {
      text: function text(trigger) {
        var codeStr = _this.generateCode();
        _this.$notify({
          title: '成功',
          message: '代码已复制到剪切板，可粘贴。',
          type: 'success'
        });
        return codeStr;
      }
    });
    clipboard.on('error', function (e) {
      _this.$message.error('代码复制失败');
    });
  },
  methods: {
    markLegacyFields: function markLegacyFields(list) {
      var _this2 = this;
      if (!Array.isArray(list)) return;
      list.forEach(function (item) {
        if (item.__config__) {
          _this2.$set(item.__config__, '__legacyField', true);
        }
        if (item.__config__ && Array.isArray(item.__config__.children)) {
          _this2.markLegacyFields(item.__config__.children);
        }
      });
    },
    /** 提交前去掉仅前端使用的标记，避免写入库或影响解析 */stripLegacyMarksFromForm: function stripLegacyMarksFromForm(conf) {
      var _this3 = this;
      if (!conf || !Array.isArray(conf.fields)) return conf;
      var walk = function walk(arr) {
        arr.forEach(function (item) {
          if (item && item.__config__ && Object.prototype.hasOwnProperty.call(item.__config__, '__legacyField')) {
            _this3.$delete(item.__config__, '__legacyField');
          }
          if (item && item.__config__ && Array.isArray(item.__config__.children)) {
            walk(item.__config__.children);
          }
        });
      };
      walk(conf.fields);
      return conf;
    },
    collectColFormItems: function collectColFormItems(list) {
      var _this4 = this;
      var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!Array.isArray(list)) return acc;
      list.forEach(function (item) {
        if (!item || !item.__config__) return;
        if (item.__config__.layout === 'colFormItem' && item.__vModel__) {
          acc.push(item);
        }
        if (Array.isArray(item.__config__.children)) {
          _this4.collectColFormItems(item.__config__.children, acc);
        }
      });
      return acc;
    },
    /** 与保存时一致：当前画布 + formConf，去掉 __legacyField 标记 */buildStrippedFormConfigSnapshot: function buildStrippedFormConfigSnapshot() {
      var formConfig = JSON.parse(JSON.stringify(_objectSpread(_objectSpread({}, this.formConf), {}, {
        fields: JSON.parse(JSON.stringify(this.drawingList))
      })));
      this.stripLegacyMarksFromForm(formConfig);
      return formConfig;
    },
    refocusDrawingAfterRemove: function refocusDrawingAfterRemove() {
      var _this5 = this;
      this.$nextTick(function () {
        var len = _this5.drawingList.length;
        if (len) {
          _this5.activeFormItem(_this5.drawingList[len - 1]);
        }
      });
    },
    /** 重命名/删除已落库后通知外层关闭弹窗，避免用户继续编排与库不一致 */emitFormTemplateSynced: function emitFormTemplateSynced() {
      if (!this.serverFieldRename) return;
      this.$emit('form-template-synced');
    },
    onRenameLegacyField: function onRenameLegacyField(element) {
      if (!element || !element.__config__ || !element.__config__.__legacyField) return;
      this.renameLegacyDialog.target = element;
      this.renameLegacyDialog.newVModel = element.__vModel__ || '';
      this.renameLegacyDialog.visible = true;
    },
    submitRenameLegacyField: function submitRenameLegacyField() {
      var _this6 = this;
      var target = this.renameLegacyDialog.target;
      var name = (this.renameLegacyDialog.newVModel || '').trim();
      if (!target || !name) {
        this.$message.warning('请输入字段名');
        return;
      }
      if (!/^[_a-zA-Z][\w]*$/.test(name)) {
        this.$message.warning('字段名需以字母或下划线开头，仅含字母、数字、下划线');
        return;
      }
      var all = this.collectColFormItems(this.drawingList, []);
      var dup = all.some(function (it) {
        return it !== target && it.__vModel__ === name;
      });
      if (dup) {
        this.$message.warning('字段名已存在，请换一个');
        return;
      }
      var oldName = target.__vModel__;
      if (oldName === name) {
        this.$message.warning('字段名未变化');
        return;
      }
      var confirmBody = this.serverFieldRename ? '此操作会立即生效并影响线上数据：表单模板 JSON、默认配置表以及各租户配置表中该字段的 name 与 title 将统一为新字段名（二者一致）（与顶部「保存」无关），相关 Redis 也会刷新。若新字段名与其它表单或配置冲突，系统将拒绝执行。是否确认立即执行？' : '将仅更新当前设计器中的字段名；保存表单后才会写入模板 JSON，且不会调用服务端批量同步配置表。是否继续？';
      this.$confirm(confirmBody, '请再次确认', {
        type: 'warning',
        confirmButtonText: this.serverFieldRename ? '立即执行' : '确定'
      }).then(function () {
        if (!_this6.serverFieldRename) {
          _this6.$set(target, '__vModel__', name);
          _this6.renameLegacyDialog.visible = false;
          _this6.renameLegacyDialog.target = null;
          _this6.$message.success('字段名已更新，请保存表单以写入模板');
          return;
        }
        if (!_this6.selfForm.id) {
          _this6.$message.error('请先保存表单模板后再使用「立即同步重命名」。');
          return;
        }
        _this6.renameLegacySubmitting = true;
        return systemFormConfigApi.renameFormFieldVmModel({
          formId: _this6.selfForm.id,
          oldFieldName: oldName,
          newFieldName: name
        }).then(function () {
          _this6.$set(target, '__vModel__', name);
          _this6.renameLegacyDialog.visible = false;
          _this6.renameLegacyDialog.target = null;
          _this6.emitFormTemplateSynced();
        }).finally(function () {
          _this6.renameLegacySubmitting = false;
        });
      }).catch(function () {});
    },
    activeFormItem: function activeFormItem(element) {
      this.activeData = element;
      this.activeId = element.__config__.formId;
    },
    onEnd: function onEnd(obj) {
      if (obj.from !== obj.to) {
        this.activeData = tempActiveData;
        this.activeId = this.idGlobal;
      }
    },
    addComponent: function addComponent(item) {
      var clone = this.cloneComponent(item);
      this.drawingList.push(clone);
      this.activeFormItem(clone);
    },
    cloneComponent: function cloneComponent(origin) {
      var clone = JSON.parse(JSON.stringify(origin));
      var config = clone.__config__;
      config.formId = ++this.idGlobal;
      config.span = this.formConf.span;
      config.renderKey = +new Date(); // 改变renderKey后可以实现强制更新组件
      if (config.layout === 'colFormItem') {
        clone.__vModel__ = "field".concat(this.idGlobal);
        clone.placeholder !== undefined && (clone.placeholder += config.label);
      } else if (config.layout === 'rowFormItem') {
        config.componentName = "row".concat(this.idGlobal);
        config.gutter = this.formConf.gutter;
      }
      tempActiveData = clone;
      return tempActiveData;
    },
    AssembleFormData: function AssembleFormData() {
      this.formData = _objectSpread({
        fields: JSON.parse(JSON.stringify(this.drawingList))
      }, this.formConf);
    },
    generate: function generate(data) {
      var func = this["exec".concat((0, _index.titleCase)(this.operationType))];
      this.generateConf = data;
      func && func(data);
    },
    execRun: function execRun(data) {
      this.AssembleFormData();
      this.drawerVisible = true;
    },
    execDownload: function execDownload(data) {
      var codeStr = this.generateCode();
      var blob = new Blob([codeStr], {
        type: 'text/plain;charset=utf-8'
      });
      (0, _fileSaver.saveAs)(blob, data.fileName);
    },
    execCopy: function execCopy(data) {
      document.getElementById('copyNode').click();
    },
    empty: function empty() {
      var _this7 = this;
      this.$confirm('确定要清空所有组件吗？', '提示', {
        type: 'warning'
      }).then(function () {
        _this7.drawingList = [];
        _this7.idGlobal = 100;
      });
    },
    drawingItemCopy: function drawingItemCopy(item, parent) {
      var clone = JSON.parse(JSON.stringify(item));
      clone = this.createIdAndKey(clone);
      if (clone.__config__) {
        this.$delete(clone.__config__, '__legacyField');
      }
      parent.push(clone);
      this.activeFormItem(clone);
    },
    createIdAndKey: function createIdAndKey(item) {
      var _this8 = this;
      var config = item.__config__;
      config.formId = ++this.idGlobal;
      config.renderKey = +new Date();
      if (config.layout === 'colFormItem') {
        item.__vModel__ = "field".concat(this.idGlobal);
      } else if (config.layout === 'rowFormItem') {
        config.componentName = "row".concat(this.idGlobal);
      }
      if (Array.isArray(config.children)) {
        config.children = config.children.map(function (childItem) {
          return _this8.createIdAndKey(childItem);
        });
      }
      return item;
    },
    drawingItemDelete: function drawingItemDelete(index, parent) {
      var _this9 = this;
      var row = parent[index];
      var isLegacy = !!(row && row.__config__ && row.__config__.__legacyField);
      var doSplice = function doSplice() {
        parent.splice(index, 1);
        _this9.refocusDrawingAfterRemove();
      };
      if (isLegacy) {
        var removedModels = this.collectColFormItems([row], []).map(function (it) {
          return it.__vModel__;
        }).filter(Boolean);
        var namesHint = removedModels.length ? "\u6D89\u53CA\u5B57\u6BB5\uFF1A".concat(removedModels.join('、'), "\u3002") : '（本节点无独立字段名，仅删除布局。）';
        var confirmBody = this.serverFieldRename ? "\u6B64\u64CD\u4F5C\u4F1A\u7ACB\u5373\u751F\u6548\uFF1A\u5C06\u4ECE\u8868\u5355\u6A21\u677F\u6301\u4E45\u5316 JSON \u4E2D\u79FB\u9664\u8BE5\u8282\u70B9\uFF08\u542B\u5176\u5B50\u5B57\u6BB5\uFF09\uFF0C\u5E76\u5220\u9664\u9ED8\u8BA4\u914D\u7F6E\u4E0E\u5404\u79DF\u6237\u914D\u7F6E\u8868\u4E2D\u4E0A\u8FF0\u5B57\u6BB5\u540D\u7684\u914D\u7F6E\u884C\uFF0C\u76F8\u5173 Redis \u4F1A\u5237\u65B0\uFF1B\u4E0E\u9876\u90E8\u300C\u4FDD\u5B58\u300D\u65E0\u5173\u3002".concat(namesHint, "\u662F\u5426\u786E\u8BA4\u7ACB\u5373\u5220\u9664\uFF1F") : '将仅从当前设计器中移除该节点；保存表单后才会写入模板，且不会调用服务端批量删除配置表数据。是否继续？';
        this.$confirm(confirmBody, '请再次确认', {
          type: 'warning',
          confirmButtonText: this.serverFieldRename ? '立即删除' : '确定'
        }).then(function () {
          if (!_this9.serverFieldRename) {
            doSplice();
            _this9.$message.success('已从画布移除，请保存表单以写入模板');
            return;
          }
          if (!_this9.selfForm.id) {
            _this9.$message.error('请先保存表单模板后再使用「立即同步删除」。');
            return;
          }
          var backupRow = JSON.parse(JSON.stringify(row));
          parent.splice(index, 1);
          _this9.refocusDrawingAfterRemove();
          _this9.$nextTick(function () {
            var snapshot = _this9.buildStrippedFormConfigSnapshot();
            systemFormConfigApi.removeFormFieldsAndSync({
              formId: _this9.selfForm.id,
              fieldNames: removedModels,
              content: JSON.stringify(snapshot)
            }).then(function () {
              _this9.emitFormTemplateSynced();
            }).catch(function () {
              parent.splice(index, 0, backupRow);
              _this9.$nextTick(function () {
                _this9.activeFormItem(backupRow);
              });
              _this9.$message.error('同步删除失败，已恢复该组件');
            });
          });
        }).catch(function () {});
        return;
      }
      doSplice();
    },
    generateCode: function generateCode() {
      var type = this.generateConf.type;
      this.AssembleFormData();
      var script = (0, _html.vueScript)((0, _js.makeUpJs)(this.formData, type));
      var html = (0, _html.vueTemplate)((0, _html.makeUpHtml)(this.formData, type));
      var css = (0, _html.cssStyle)((0, _css.makeUpCss)(this.formData));
      return beautifier.html(html + script + css, _index.beautifierConf.html);
    },
    showJson: function showJson() {
      this.AssembleFormData();
      this.jsonDrawerVisible = true;
    },
    handlerSaveJSON: (0, _validate.Debounce)(function (form) {
      var _this10 = this;
      // this.AssembleFormData()
      // loadBeautifier(btf => {
      //   beautifier = btf
      //   let jsonStr = JSON.stringify(this.formData)
      //   this.beautifierJson = beautifier.js(jsonStr, beautifierConf.js)
      //
      // })
      this.$refs[form].validate(function (result) {
        if (!result) return;
        var formConfig = (0, _db.getFormConfSelf)();
        if (formConfig.fields.length === 0) {
          _this10.$message.error('表单配置数据不能为空');
          return;
        }
        _this10.stripLegacyMarksFromForm(formConfig);
        _this10.selfForm.content = JSON.stringify(formConfig);
        _this10.$emit('getFormConfigDataResult', _this10.selfForm);
      });
    }),
    download: function download() {
      this.dialogVisible = true;
      this.showFileName = true;
      this.operationType = 'download';
    },
    run: function run() {
      this.dialogVisible = true;
      this.showFileName = false;
      this.operationType = 'run';
    },
    copy: function copy() {
      this.dialogVisible = true;
      this.showFileName = false;
      this.operationType = 'copy';
    },
    tagChange: function tagChange(newTag) {
      var _this11 = this;
      if (this.activeData.__config__ && this.activeData.__config__.__legacyField) {
        this.$message.warning('历史字段不可更换组件类型');
        return;
      }
      newTag = this.cloneComponent(newTag);
      var config = newTag.__config__;
      newTag.__vModel__ = this.activeData.__vModel__;
      config.formId = this.activeId;
      config.span = this.activeData.__config__.span;
      this.activeData.__config__.tag = config.tag;
      this.activeData.__config__.tagIcon = config.tagIcon;
      this.activeData.__config__.document = config.document;
      if (_typeof(this.activeData.__config__.defaultValue) === _typeof(config.defaultValue)) {
        config.defaultValue = this.activeData.__config__.defaultValue;
      }
      Object.keys(newTag).forEach(function (key) {
        if (_this11.activeData[key] !== undefined) {
          newTag[key] = _this11.activeData[key];
        }
      });
      this.activeData = newTag;
      this.updateDrawingList(newTag, this.drawingList);
    },
    updateDrawingList: function updateDrawingList(newTag, list) {
      var _this12 = this;
      var index = list.findIndex(function (item) {
        return item.__config__.formId === _this12.activeId;
      });
      if (index > -1) {
        list.splice(index, 1, newTag);
      } else {
        list.forEach(function (item) {
          if (Array.isArray(item.__config__.children)) _this12.updateDrawingList(newTag, item.__config__.children);
        });
      }
    },
    refreshJson: function refreshJson(data) {
      this.drawingList = JSON.parse(JSON.stringify(data.fields));
      delete data.fields;
      this.formConf = data;
    }
  }
};